import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
    environmentState,
    lowerSideViewState,
    mainViewState,
    upperSideViewState,
    viewManagerState,
} from '~/state/atoms/engineAtoms';
import { windowLevelState } from '~/state/atoms/toolsAtoms';

export default function useViewManagerEvents() {
    const environment = useRecoilValue(environmentState);
    const viewManager = useRecoilValue(viewManagerState);
    const mainView = useRecoilValue(mainViewState);
    const upperSideView = useRecoilValue(upperSideViewState);
    const lowerSideView = useRecoilValue(lowerSideViewState);
    const setWindowLevel = useSetRecoilState(windowLevelState);

    const handleWindowLevelChange = () => {
        if (environment && environment.image) {
            const windowLevel = environment.image.windowLevel;
            if (windowLevel) {
                setWindowLevel(windowLevel);
            }
        }
    };

    useEffect(() => {
        viewManager?.addEventListener(
            'windowlevel_changed',
            handleWindowLevelChange
        );

        return () => {
            viewManager?.removeEventListener(
                'windowlevel_changed',
                handleWindowLevelChange
            );
        };
    }, [viewManager]);

    const focusOnStructure = (roiNumber: number) => {
        if (
            environment &&
            mainView &&
            upperSideView &&
            lowerSideView &&
            environment.structureSet
        ) {
            const roi = environment.structureSet.getRoi(roiNumber);
            if (roi) {
                environment.panZoom.focusTo(
                    mainView,
                    upperSideView,
                    lowerSideView,
                    roi.boundingBox
                );
            }
        }
    };

    return { focusOnStructure };
}
